import { Controller } from "@hotwired/stimulus"

// Submits the form as soon as a control changes (a select that navigates).
export default class extends Controller {
  submit() {
    if (typeof this.element.requestSubmit === "function") this.element.requestSubmit()
    else this.element.submit()
  }
}
